import {
    AuthConfig,
    EnvironmentConfig,
    EnvironmentName,
} from '../company.types';

const localConfig: AuthConfig = {
    issuer: 'https://auth-debtor-nonprod.faasbytriumph.io/oauth2/default',
    clientId: '0oar11ax7g2NteMUz1d7',
    webAppClientId: '0oar11ax7g2NteMUz1d7',
    baseUrl: 'http://localhost:3000',
};

const devConfig: AuthConfig = {
    issuer: 'https://auth-debtor-nonprod.faasbytriumph.io/oauth2/default',
    clientId: '0oar11ax7g2NteMUz1d7',
    webAppClientId: '0oar11ax7g2NteMUz1d7',
    baseUrl: 'https://invoices.dev.faasbytriumph.io',
};

const qaConfig: AuthConfig = {
    issuer: 'https://auth-debtor-nonprod.faasbytriumph.io/oauth2/default',
    clientId: '0oar11ax7g2NteMUz1d7',
    webAppClientId: '0oar11ax7g2NteMUz1d7',
    baseUrl: 'https://invoices.qa.faasbytriumph.io',
};

const uatConfig: AuthConfig = {
    issuer: 'https://auth-debtor-nonprod.faasbytriumph.io/oauth2/default',
    clientId: '0oagl2avyed9kNASw1d7',
    webAppClientId: '0oagl2avyed9kNASw1d7',
    baseUrl: 'https://apply.uat.myfactoringservice.com',
};

const prodConfig: AuthConfig = {
    issuer: 'https://auth-debtor.faasbytriumph.io/oauth2/default',
    clientId: '0oa1yms1qzkGtzx7W1d8',
    webAppClientId: '0oa1yms1qzkGtzx7W1d8',
    baseUrl: 'https://invoices.faasbytriumph.io',
};

export const environmentConfigs: EnvironmentConfig = {
    [EnvironmentName.LOCAL]: localConfig,
    [EnvironmentName.TEST]: localConfig,
    [EnvironmentName.DEV]: devConfig,
    [EnvironmentName.QA]: qaConfig,
    [EnvironmentName.UAT]: uatConfig,
    [EnvironmentName.PROD]: prodConfig,
};
